// extracted by mini-css-extract-plugin
module.exports = {"header":"StickyHeader_header__2rXCG","sticky":"StickyHeader_sticky__7-6XX","title":"StickyHeader_title__b1iIk"};